export default {"src":"/_next/static/media/orange.eee05152.svg","height":22,"width":23};